<template>
  <div>
    <v-container>
      <v-layout>
        <v-flex xs12 sm6>
          <v-btn
            depressed
            :outline="filter != ''"
            :color="filter == '' ? 'primary' : 'grey'"
            @click="changeApp('')"
            class="ma-0 mr-1 mb-1"
            >{{ $t('All') }}</v-btn
          >
          <v-btn
            depressed
            :outline="filter != 'facebook'"
            :color="filter == 'facebook' ? 'primary' : 'grey'"
            @click="changeApp('facebook')"
            class="ma-0 mr-1 mb-1"
          >
            <em class="fab fa-facebook-square mr-1" />
            {{ $t('Facebook') }}
          </v-btn>
          <v-btn
            depressed
            :outline="filter != 'line'"
            :color="filter == 'line' ? 'primary' : 'grey'"
            @click="changeApp('line')"
            class="ma-0 mr-1 mb-1"
          >
            <em class="fab fa-line mr-1" />
            {{ $t('Line') }}
          </v-btn>
        </v-flex>
        <v-flex xs12 sm6 class="text-sm-right">
          <template v-if="loading">
            <v-btn :loading="true" color="grey" outline class="ma-0 mb-1"></v-btn>
          </template>
          <template v-else>
            <v-btn @click="exportData" color="grey" outline class="ma-0 mb-1">
              <em class="fas fa-file-export mr-1" />
              {{ $t('export') }}
            </v-btn>
          </template>
        </v-flex>
      </v-layout>
      <date-filter
        @changeDate="getData"
        :defaultFilter="'today'"
        v-model="selectedDate"
      ></date-filter>
      <template v-if="!loading">
        <div v-if="data && data.length">
          <div class="mt-3 mb-2">
            <multiselect
              selectLabel
              @input="changeRound"
              :allowEmpty="false"
              selectedLabel
              :searchable="false"
              deselect-label
              v-model="round"
              :options="rounds"
            ></multiselect>
          </div>
          <div style="position: relative">
            <div style="font-weight: 600; font-size: 20px" class="text-xs-center my-3">
              คะแนนโหวต
            </div>
            <div style="position: absolute; left: 5px; top: 25px">
              รวม: <span style="font-size: 20px">{{ total.toLocaleString() }}</span>
            </div>
            <apexchart
              :key="barchartkey"
              type="bar"
              height="400"
              :options="chartOptions"
              :series="series"
            ></apexchart>
          </div>
        </div>
        <div v-else>
          <h4 style="color: darkgrey" class="text-xs-center mt-5">ยังไม่มีข้อมูลการโหวต</h4>
        </div>
      </template>
      <div v-else class="text-xs-center mt-5">
        <v-progress-circular
          class="mx-auto"
          indeterminate
          color="primary"
          size="60"
        ></v-progress-circular>
      </div>
    </v-container>
  </div>
</template>

<script>
import api from '@/api'
import DateFilter from '../../DateFilter.vue'
import { mapGetters } from 'vuex'
import moment from 'moment'
import apexchart from 'vue-apexcharts'
import XLSX from 'xlsx'
import Multiselect from 'vue-multiselect'
export default {
  computed: {
    ...mapGetters(['selectedBot']),
    rounds() {
      return this.data.map((el) => el.name)
    }
  },
  components: {
    DateFilter,
    apexchart,
    Multiselect
  },
  data() {
    return {
      barchartkey: 0,
      series: [
        {
          name: 'vote',
          data: []
        }
      ],
      chartOptions: {
        title: {
          align: 'center',
          style: {
            fontSize: '18px',
            fontWeight: 'bold',
            fontFamily: 'Roboto',
            color: 'grey'
          }
        },
        chart: {
          events: {
            dataPointSelection: this.barclick
          },
          height: 650,
          width: '30',
          type: 'bar'
        },
        theme: {
          palette: 'palette1' // upto palette10
        },
        plotOptions: {
          bar: {
            columnWidth: '5px',
            distributed: true,
            dataLabels: {
              position: 'right' // top, center, bottom
            }
          }
        },
        responsive: [
          {
            breakpoint: undefined,
            options: {}
          }
        ],
        dataLabels: {
          enabled: true,
          formatter: null,
          offsetY: 20,

          style: {
            fontSize: '12px',
            colors: ['#304758']
          }
        },

        xaxis: {
          categories: [],
          position: 'bottom',
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          },
          crosshairs: {
            fill: {
              colors: ['#F44336', '#E91E63', '#9C27B0']
            }
          },
          tooltip: {
            enabled: true
          }
        },
        yaxis: {
          show: false,
          axisBorder: {
            show: false
          },
          max: this.maxY,
          forceNiceScale: true,
          axisTicks: {
            show: false
          }
        }
      },
      data: [],
      round: '',
      filter: '',
      loading: false,
      selectedDate: {
        start: moment().format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      exportloading: false,
      count: 0
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    maxY(max) {
      return max + max / 3
    },
    exportData() {
      let vm = this
      let header = 'data:text/csv;charset=utf-8,%EF%BB%BF'
      let csvContent = ''
      let orders = []
      let filename = 'VotingResult'

      var json = []
      var currentData = this.data.find((el) => el.name == this.round)
      json = this.data.map((el) => {
        var answer = []
        var ages = []
        for (const [key, value] of Object.entries(el.answer)) {
          answer.push(key + ' : ' + value)
        }
        for (const [key, value] of Object.entries(el.ages)) {
          ages.push('อายุ ' + key + ' : ' + value + 'คน')
        }

        return {
          Question: el.name,
          Answer: answer.join(','),
          Ages: ages.join(',')
        }
      })

      var dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, filename + '.xlsx')
    },
    changeRound() {
      this.count = 0
      var data = this.data.find((el) => el.name == this.round)

      var categories = []
      var seriesvalue = []
      for (const [key, value] of Object.entries(data.answer)) {
        categories.push(key)
        seriesvalue.push(parseInt(value))
      }
      this.chartOptions.xaxis.categories = categories
      this.series[0].data = seriesvalue
      this.total = data.total
      this.barchartkey = new Date().getTime()
    },
    getPercent(quantity) {
      var total = this.total

      return (parseFloat(quantity) / total) * 100
    },
    barclick() {},
    changeApp(item) {
      this.filter = item
      this.getData()
    },
    exportDashboard() {},
    getData() {
      var data = {
        pageid: this.selectedBot.pageid, // required
        topic: '', // ชื่อคำถาม
        datefrom: moment(this.selectedDate.start).format('YYYY-MM-DD'), // YYYY-MM-DD
        dateto: moment(this.selectedDate.end).format('YYYY-MM-DD'), // YYYY-MM-DD
        app: this.filter
      }
      this.loading = true
      api.postterovoteresult(data, (err, response) => {
        this.loading = false
        if (response.responsecode == 200) {
          if (response.data && response.data.length) {
            this.data = response.data[0]
            var data = []
            for (const [key, value] of Object.entries(this.data)) {
              data.push({
                name: key,
                ...value
              })
            }
            this.data = data
            this.round = data[0].name
            var categories = []
            var seriesvalue = []
            for (const [key, value] of Object.entries(this.data[0].answer)) {
              categories.push(key)
              seriesvalue.push(parseInt(value))
            }

            this.chartOptions.xaxis.categories = categories
            this.series[0].data = seriesvalue
            this.total = this.data[0].total
            this.count = 0
            this.chartOptions.dataLabels.formatter = (val, opt) => {
              var total = this.total
              var percentdata = Math.round(Number((parseFloat(val) / total) * 100))
              return `${val} (${percentdata + '%'})`
            }
            this.barchartkey = new Date().getTime()
          } else {
            this.data = []
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/customize/tero/VotingResult.vue